import { api, lang } from 'config';
const MARKDOWN_START = '%';
const STATUS_TYPE_SUCCESS = 'success';
const STATUS_TYPE_ERROR = 'error';
const STATUS_TYPE_WARNING = 'warning';

export const validationsForm = (rules) => {

    const uncapitalize = (str) => {
        return str.substring(0, 1).toLowerCase() + str.substring(1);
    };

    let validated = true;

    const fieldsStatus = {};
    const fieldsStatusType = {};

    const checkValid = (valid, field, error, type) => {
        const statusType = (!valid) ? (type || STATUS_TYPE_ERROR) : (type || STATUS_TYPE_SUCCESS);
        fieldsStatusType[field] = {
            type: statusType,
            message: statusType !== STATUS_TYPE_ERROR  ? error : null,
        };
        fieldsStatus[field] = (!valid) ? error : true;
        validated = validated && valid;
        return !valid;
    };

    rules.forEach((rule) => {
        const validations = rule.validations;
        const ref = rule.ref;
        const field = ref.current.name;
        const value = ref.current.type === 'checkbox' ? ref.current.checked : ref.current.value;

        validations.some((validationField) => {
            const type = validationField.type;
            const options = typeof validationField.options !== 'undefined' ? validationField.options : {};
            const value2 = typeof options.value2 !== 'undefined' ? options.value2.current.value : null;
            let error = typeof validationField.error !== 'undefined' ? validationField.error : '';
            let valid;
            let min;
            let max;
            let request;
            let statusType;

            switch (type) {
                case 'required':
                    valid = typeof value !== 'undefined' && !!value.toString().trim();
                    break;

                case 'length':
                    min = typeof options.min !== 'undefined' ? options.min : null;
                    max = typeof options.max !== 'undefined' ? options.max : null;
                    valid = min !== null && max !== null && typeof value !== 'undefined' && value.length >= min && value.length <= max;
                    break;

                case 'greater':
                    min = typeof options.min !== 'undefined' ? options.min : null;
                    valid = min !== null && typeof value !== 'undefined' && !isNaN(parseFloat(value)) && !isNaN(min) && parseFloat(value) > parseFloat(min);
                    break;

                case 'greater-equal':
                    min = typeof options.min !== 'undefined' ? options.min : null;
                    valid = min !== null && typeof value !== 'undefined' && !isNaN(parseFloat(value)) && !isNaN(min) && parseFloat(value) >= parseFloat(min);
                    break;

                case 'less':
                    max = typeof options.max !== 'undefined' ? options.max : null;
                    valid = max !== null && typeof value !== 'undefined' && !isNaN(parseFloat(value)) && !isNaN(max) && parseFloat(value) < parseFloat(max);
                    break;

                case 'less-equal':
                    max = typeof options.max !== 'undefined' ? options.max : null;
                    valid = max !== null && typeof value !== 'undefined' && !isNaN(parseFloat(value)) && !isNaN(max) && parseFloat(value) <= parseFloat(max);
                    break;

                case 'format-number':
                    valid = typeof value !== 'undefined' && value !== '' && !value.search(/^[0-9]*\.?[0-9]*$/) && !isNaN(parseFloat(value));
                    break;

                case 'alphanumeric':
                    valid = typeof value !== 'undefined' && value.search('^[a-zA-Z0-9]+$') !== -1;
                    break;

                case 'equalsValueInput':
                    valid = value2 && typeof value !== 'undefined' && value == value2;
                    break;

                case 'email':
                    valid = typeof value !== 'undefined' && value.search(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/) !== -1;
                    break;

                case 'web':
                    valid = typeof value !== 'undefined' && (value == '' || value !== '' && value.search(/^(?:https?:\/\/){0,1}(?:[\da-z\.-]+)\.(?:[a-z\.]{2,6})(?:[\/\w \.-]*)*\/?$/) !== -1);
                    break;

                case 'requiredCheck':
                    valid = typeof value !== 'undefined' && value;
                    break;

                case 'hasHTML':
                    valid = !(/.*<[^>]+>.*/g.test(value));
                    break;

                case 'passwordRegister':
                    if (typeof value !== 'undefined') {
                        const LOWER = /[a-z]/;
                        const UPPER = /[A-Z]/;
                        const DIGIT = /[0-9]/;
                        const SPECIAL = /[^a-zA-Z0-9]/;
                        const SAME = /^(.)\1+$/;
                        const lower = LOWER.test(value);
                        const upper = UPPER.test(uncapitalize(value));
                        const digit = DIGIT.test(value);
                        const special = SPECIAL.test(value);

                        valid = false;
                        let errorPassword = '';

                        if (!value || value.length == 0) {
                            errorPassword = error;
                        } else if (!value || value.length < 8) {
                            errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.length`;
                        } else if (SAME.test(value)) {
                            errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.password-very-weak`;
                        }
                        if (errorPassword === '') {
                            let totalValidGroups = 0;
                            if (lower) totalValidGroups += 1;
                            if (upper) totalValidGroups += 1;
                            if (digit) totalValidGroups += 1;
                            if (special) totalValidGroups += 1;

                            if (value.length < 8) {
                                errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.password-very-weak`;
                            } else if (value.length < 10) {
                                if (totalValidGroups === 4) {
                                    valid = true;
                                    errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.password-high`;
                                } else if (totalValidGroups === 1) {
                                    errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.password-very-weak`;
                                } else {
                                    valid = true;
                                    errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.password-weak`;
                                    statusType = STATUS_TYPE_WARNING;
                                }
                            } else {
                                if (totalValidGroups > 2) {
                                    valid = true;
                                    errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.password-high`;
                                } else if (totalValidGroups === 1) {
                                    errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.password-very-weak`;
                                } else {
                                    valid = true;
                                    errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.password-weak`;
                                    statusType = STATUS_TYPE_WARNING;
                                }
                            }
                        }
                        if (value2 && value.toLowerCase().indexOf(value2.toLowerCase()) !== -1) {
                            errorPassword = `${MARKDOWN_START}new-login.signup-form.password.error.username`;
                            statusType = STATUS_TYPE_ERROR;
                            valid = false;
                        }
                        error = errorPassword;
                    } else {
                        valid = false;
                    }
                    break;

                case 'checkUsername':
                    if (value && value.length > 3) {
                        request = new XMLHttpRequest();
                        request.open('GET', `${api}/user/users/${value}/username/exists`, false);
                        request.setRequestHeader('Content-Type', 'application/json');
                        request.setRequestHeader('Accept-Language', lang);
                        request.send();
                        valid = typeof JSON.parse(request.response) !== 'undefined' && typeof JSON.parse(request.response).exists !== 'undefined' && !JSON.parse(request.response).exists;
                    } else {
                        valid = false;
                    }
                    if (!valid) {
                        statusType = STATUS_TYPE_WARNING;
                    }
                    break;

                case 'checkEmail':
                    if (value && value.length > 3) {
                        request = new XMLHttpRequest();
                        request.open('GET', `${api}/user/users/${value}/email/exists`, false);
                        request.setRequestHeader('Content-Type', 'application/json');
                        request.setRequestHeader('Accept-Language', lang);
                        request.send();
                        valid = typeof JSON.parse(request.response) !== 'undefined' && typeof JSON.parse(request.response).exists !== 'undefined' && !JSON.parse(request.response).exists;
                    } else {
                        valid = false;
                    }
                    if (!valid) {
                        statusType = STATUS_TYPE_WARNING;
                    }
                    break;

                default:
                    valid = false;
            }

            return checkValid(valid, field, error, statusType);
        });
    });

    return {
        validated,
        fieldsStatus,
        fieldsStatusType,
    };
};

export const checkCustomErrorMessage = (error) => {
    return typeof error === 'string' && error.startsWith(MARKDOWN_START) ? error.replace(new RegExp('^'.concat(MARKDOWN_START)), '') : null;
};

export const checkStatusField = (error) => {
    const errorStatus = typeof error !== 'undefined' ? typeof error === 'string' ? error : '' : null;
    return {
        error,
        status: errorStatus !== null ? errorStatus === '' ? 'success' : 'error' : '',
    };
};
